import { RowDataStaff } from "../../components/StaffPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the StaffTable factory
 */
class StaffRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/staff/read-range"
        this.accessData = "staffs"
    }

    create(staff: any): RowDataStaff {
        const rowDataStaff: RowDataStaff = {
            staffId: staff.staff_id,
            name: staff.fullname,
            phone_number: staff.phone_number,
            email: staff.email,
            KPI: staff.kpi,
            password: "",
            reenterPassword: "",
            action: "",
        };
        return rowDataStaff;
    }
}

let staffRow: StaffRow | null = null;

export default function getStaffRow(): StaffRow {
    if (staffRow === null)
        staffRow = new StaffRow()
    return staffRow
}